export const VOCABULARY_DRAFT_MAX_LENGTH = 80_000;
export type VocabularyDraft = { sourceText: string; revision: number; updatedAt: number };
export type VocabularyDraftResponse = { accountId: string; draft: VocabularyDraft | null };
export const isVocabularyDraft = (value: unknown): value is VocabularyDraft => {
    if (!value || typeof value !== "object") return false;
    const draft = value as VocabularyDraft;
    return typeof draft.sourceText === "string" && draft.sourceText.length <= VOCABULARY_DRAFT_MAX_LENGTH
        && Number.isSafeInteger(draft.revision) && draft.revision >= 1
        && Number.isSafeInteger(draft.updatedAt) && draft.updatedAt > 0;
};
